import { jsx } from 'react/jsx-runtime';
import cn from 'classnames';
import { Button } from '../../Button/Button.js';
import S from './SubmitButtons.styl.js';

const SubmitButtons = ({ buttons, className, ...props }) => (jsx("div", { className: cn(S.root, className), ...props, children: buttons.map(buttonProps => (jsx(Button, { className: cn(S.item, buttonProps.className), ...buttonProps }))) }));

export { SubmitButtons };
